// libs
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// types
import { Reducers } from 'store/types'
import { IObjectSecurity } from 'types/graphql'

export interface ObjectSecuritiesState {
  data: IObjectSecurity[]
}

const initialState: ObjectSecuritiesState = {
  data: []
}

export const objectSecuritiesSlice = createSlice({
  name: Reducers.OBJECT_SECURITIES,
  initialState,
  reducers: (create) => ({
    setObjectSecurities: create.reducer((state, action: PayloadAction<IObjectSecurity[]>) => {
      state.data = action.payload
    }),
    updateObjectSecurities: create.reducer(
      (state, action: PayloadAction<{ id: string, data: IObjectSecurity }>) => {
        state.data = state.data.map(item => {
          if (item.id === action.payload.id) {
            return { ...item, ...action.payload.data }
          }
          return item
        })
      }
    )
  }),
  selectors: {
    objectSecuritiesSelector: (state) => state.data
  }
})

export const {
  setObjectSecurities,
  updateObjectSecurities
} =
  objectSecuritiesSlice.actions

export const { objectSecuritiesSelector } = objectSecuritiesSlice.selectors
